// ---------------------------------------------------------------------------
// Which way the camera moves.
//
// The browser animates the navigation; all this decides is the direction. Going
// from the hub into a chapter pushes in, coming back pulls out, and stepping
// along the sequence just slides. The direction lands on <html> as an attribute
// and the keyframes hang off that — no JavaScript touches the animation itself.
//
// Both halves of a cross-document transition have to agree, so the outgoing
// document works it out from the link that was clicked and the incoming one
// from document.referrer. Neither needs the Navigation API, which Safari does
// not have.
// ---------------------------------------------------------------------------

const HUB = '/uohs/'

const direction = (from, to) => {
    if (!from || !to || from === to) return null
    if (to === HUB) return 'out'
    if (from === HUB) return 'in'

    return from.startsWith('/uohs/') && to.startsWith('/uohs/') ? 'along' : null
}

const mark = (from, to) => {
    const way = direction(from, to)

    if (way) document.documentElement.dataset.flight = way
    else delete document.documentElement.dataset.flight
}

const path = (href) => {
    try {
        const url = new URL(href, window.location.href)
        return url.origin === window.location.origin ? url.pathname : null
    } catch {
        return null
    }
}

export function flight() {
    // Arriving: the referrer says where we came from.
    mark(path(document.referrer), window.location.pathname)

    // Leaving: the link says where we are going. Captured on the way down so it
    // is set before the browser takes its snapshot.
    document.addEventListener(
        'click',
        (event) => {
            const link = event.target.closest?.('a[href]')
            if (link) mark(window.location.pathname, path(link.href))
        },
        true
    )
}
